// 1.

import React, { useState, useEffect, useContext } from "react";
import logo from '../../../../assets/img/logos/logo 2.png';
import { BusinessApi } from "../../../../api/Api";
import TopHeader from "../../../../components/general/TopHeader";
import { AuthenticationContext } from "../../../../context/AuthenticationContext";
import { Link, useNavigate } from 'react-router-dom';
import { Height } from "@mui/icons-material";
import AxiosApi, { APP_KEY } from "../../../../api/AxiosApi";
import TopHeaderBusiness from "../../../../components/general/TopHeaderBusiness";
import Header2 from "../../../../components/dashboard/Header2";
import AlarmIcon from "@mui/icons-material/Alarm";
import * as XLSX from "xlsx";

import "./BusinessInner.css";
import BottomSliderBuss from "../business/bottomSliderBuss/BottomSliderBuss";
import UpdateComponent from "../../../../components/updateComponent/UpdateComponent";
import { AppThemeContext } from "../../../../context/AppThemeContext";
import InvoicePage from "../businessPageData/InvoicePage/InvoicePage";
import InvoiceModalPage from "../businessPageData/InvoicePage/InvoiceModalPage";
import AlaramLog from "../alarmLog/AlaramLog";
import AlaramLogBusiness from "../alarmLog/AlaramLogBusiness/AlaramLogBusiness";

export default function BusinessInner() {
    const { PrimaryColor } = useContext(AppThemeContext);
    const [logData, setLogData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { userLogin } = useContext(AuthenticationContext);
    const Navigate = useNavigate()

    const [searchQuery, setSearchQuery] = useState(""); // State for search input

    const [filteredData, setFilteredData] = useState([]); // State for filtered data

    const [showAlarmOnly, setShowAlarmOnly] = useState(false); // Alarm filter state
    const [showOfflineOnly, setShowOfflineOnly] = useState(false); // Offlien filter state
    const [showOnlineOnly, setShowOnlineOnly] = useState(false); // Offlien filter state
    const [showPartialOfflineOnly, setShowPartialOfflineOnly] = useState(false); // Offlien filter state
    const [showExpiryOnly, setShowExpiryOnly] = useState(false); // Offlien filter state
    const [offlineCount, setOfflineCount] = useState(0);
    const [onlineCount, setOnlineCount] = useState(0);
    const [alaramCount, setAlaramCount] = useState(0)
    const [partialCount, setPartialCount] = useState(0)
    const [expiryCount, setExpiryCount] = useState(0)
    const [totalCount, setTotalCount] = useState(0)


    // this is modal code
    const [showModal, setShowModal] = useState(false);

    const [selectedUser, setSelectedUser] = useState(null);


    // 1. Selected Alarm data  state 
    const [selectedAlarm, setSelectedAlarm] = useState(null);
    const [showModal2, setShowModal2] = useState(false);

    // Pagination States
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(12);

    const [autoRefresh, setAutoRefresh] = useState(false); // ✅ checkbox state

    //This Is invoice page

    const [showInvoice, setShowInvoice] = useState(false);

    const credentials = {
        LOGIN_ID: localStorage.getItem("business_LOGIN_ID") || "",
        SS_KEY: localStorage.getItem("business_SS_KEY") || "",
    };

    // console.log("sskey2Business", credentials.SS_KEY)
    // console.log("LOGIN_IDBusiness", credentials.LOGIN_ID)


    const fetchLogData = async () => {
        setLoading(true);
        setError(null);
        setLogData([]);
        try {
            const res = await BusinessApi(credentials);
            if (res?.data && Array.isArray(res?.data)) {
                setLogData(res?.data);
            } else {
                setLogData([]);
            }
        } catch (err) {
            setError("Failed to fetch data. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    // console.log("databusiness", logData)
    // console.log("databusiness_cred", credentials)

    useEffect(() => {
        fetchLogData(); // Initial fetch

        let interval = null;

        if (autoRefresh) {
            interval = setInterval(() => {
                fetchLogData(); // Fetch every 60s if checkbox is checked
            }, 300000); // 
        }

        return () => {
            if (interval) clearInterval(interval); // Cleanup
        };
    }, [autoRefresh, credentials.LOGIN_ID]);




    useEffect(() => {
        let updatedData = logData;

        if (showAlarmOnly) {
            updatedData = updatedData.filter(item => item.ALARM && item.ALARM.trim() !== "");
        }

        if (showOfflineOnly) {
            updatedData = updatedData.filter(item =>
                item.STATUS && item.STATUS.toLowerCase() === "offline" // Correct field name
            );
        }

        if (showOnlineOnly) {
            updatedData = updatedData.filter(item =>
                item.STATUS && item.STATUS.toLowerCase() === "online" // Correct field name
            );
        }

        if (showPartialOfflineOnly) {
            updatedData = updatedData.filter(item =>
                item.STATUS && item.STATUS.toLowerCase() === "partial offline" // Correct field name
            );
        }

        if (showExpiryOnly) {
            updatedData = updatedData.filter(item => {
                if (item.subscription_expiry_date) {
                    const parts = item.subscription_expiry_date.split("-"); // Split DD-MM-YYYY
                    if (parts.length === 3) {
                        const expiryDate = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`); // Convert to YYYY-MM-DD
                        const today = new Date();

                        today.setHours(0, 0, 0, 0);
                        expiryDate.setHours(0, 0, 0, 0);

                        return expiryDate < today;  // ✅ Expiry date should be before today
                    }
                }
                return false;
            });

            console.log("Expired Subscriptions:", updatedData);  // Debugging
        }



        if (searchQuery.trim() !== "") {
            updatedData = updatedData.filter((item) =>
                Object.values(item)
                    .join(" ")
                    .toLowerCase()
                    .includes(searchQuery.toLowerCase())
            );
        }

        setFilteredData(updatedData);
        setCurrentPage(1);
    }, [searchQuery, showAlarmOnly, showOfflineOnly, logData, showPartialOfflineOnly, showExpiryOnly, showOnlineOnly]);



    useEffect(() => {
        const count = logData.filter(item =>
            item.STATUS?.toLowerCase() === "offline"
        ).length;
        setOfflineCount(count);
    }, [logData]);  // Runs whenever logData updates


    useEffect(() => {
        setTotalCount(logData.length);
    }, [logData]);  // Runs whenever logData updates

    useEffect(() => {
        const count = logData.filter(item =>
            item.STATUS?.toLowerCase() === "online"
        ).length;
        setOnlineCount(count);
    }, [logData]);  // Runs whenever logData updates


    useEffect(() => {
        if (!logData || !Array.isArray(logData)) return;
        const countAlarm = logData.filter(item =>
            item.ALARM?.toLowerCase() === "alarm"  // Fixed typo and case sensitivity
        ).length;

        setAlaramCount(countAlarm);
    }, [logData]);  // Runs whenever logData updates



    useEffect(() => {
        // if (!logData || !Array.isArray(logData)) return;

        const countPartial = logData.filter(item =>
            item.STATUS?.toLowerCase() === "partial offline"  // Fixed case sensitivity
        ).length;

        setPartialCount(countPartial);
    }, [logData]);  // Runs whenever logData updates



    useEffect(() => {
        // if (!logData || !Array.isArray(logData)) return;

        const countPartial = logData.filter(item =>
            item.STATUS?.toLowerCase() === "partial offline"  // Fixed case sensitivity
        ).length;

        setPartialCount(countPartial);
    }, [logData]);  // Runs whenever logData updates



    useEffect(() => {
        const today = new Date();
        today.setHours(0, 0, 0, 0); // ✅ Ensure time is ignored

        const countExpiry = logData.filter(item => {
            if (item.subscription_expiry_date) {
                const parts = item.subscription_expiry_date.split("-"); // Split DD-MM-YYYY
                if (parts.length === 3) {
                    const expiryDate = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`); // Convert to YYYY-MM-DD
                    expiryDate.setHours(0, 0, 0, 0); // ✅ Ensure time is ignored

                    return expiryDate < today; // ✅ Count only expired dates
                }
            }
            return false;
        }).length;

        setExpiryCount(countExpiry); // ✅ Expired subscription count update karein
    }, [logData]);  // ✅ Runs whenever `logData` updates



    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;

    // const currentData = logData.slice(indexOfFirstItem, indexOfLastItem);
    // const totalPages = Math.ceil(logData.length / itemsPerPage);

    const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);


    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    // Define static headers
    const tableHeaders = [
        "SN",
        "User/Plant Name",
        "User Id",
        // "Password",
        "Alarm",
        "Current KW",
        "Capacity",
        "Plant Location",
        "Total KWh",

        "Todays KWh",
        "Todays CUF",
        "Todays Specific Yield",
        "Todays PR",
        "Total Inverters",
        "Status",
        "Commissioned Date",
        "Subscription Expiry Date",
        "Latitude",
        "Longitude",
        "Mail Id",
        // "Invoice"

    ];

    const handleLoginClick = async (LOGIN_NAME, PW, USER_TYPE) => {
        try {
            let headersList = {
                Accept: "/",
                "Content-Type": "application/x-www-form-urlencoded",
            };

            let bodyParams = new URLSearchParams();
            bodyParams.append("LOGIN_NAME", LOGIN_NAME);
            bodyParams.append("PW", PW);
            bodyParams.append("APP_KEY", APP_KEY);

            const res = await AxiosApi.post("login/LoginWEB", bodyParams, headersList);
            const userData = res?.data;

            if (userData) {
                const encodedData = btoa(encodeURIComponent(JSON.stringify({
                    userInfo: userData,
                    loginId: LOGIN_NAME,
                    pw: PW,
                    lcode: userData?.Loc_Code,
                    isImpersonated: true
                })));

                // 🟢 लाइव फिक्स 1: 'noopener,noreferrer' के साथ 'window.open' का सही उपयोग
                // इससे नया टैब पुराने टैब के localStorage के साथ छेड़छाड़ नहीं कर पाएगा।
                const newWindow = window.open(`/#/userDashboard?token=${encodedData}`, "_blank", "noopener,noreferrer");
                if (newWindow) {
                    newWindow.opener = null; // सुरक्षा की एक और परत
                }
            }
        } catch (error) {
            console.error("Login Handler Error:", error);
        }
    };

    const handleOpenModal = (userData) => {
        setSelectedUser(userData);
        setShowModal(true);
    };

    const handleClose = () => {
        setShowModal(false);
        setSelectedUser(null);
    };

    const handleUpdate = (updatedUser) => {
        setLogData((prevData) =>
            prevData.map((user) =>
                user.USER_ID === updatedUser.USER_ID ? updatedUser : user
            )
        );
        handleClose();
    };

    // 2. Click handle करते समय item data पास करें

    // const handleOpenModal2 = (item) => {
    //     setSelectedAlarm({
    //         id: item.USER_ID,          
    //         locCode: item.LOC_CODE 
    //     });
    //     setShowModal2(true);
    // }; 

    const handleOpenModal2 = (item) => {
    const alarmValue = item?.ALARM?.toString().trim();

    // Dash ("-"), null, undefined या empty string को रोकें
    if (alarmValue && alarmValue !== "-") {
        setSelectedAlarm({
            id: item.ID,
            locCode: item.LOC_CODE
        });
        setShowModal2(true);
    }
};

    const handleClose2 = () => {
        setShowModal2(false);
        setSelectedAlarm(null);
    };

    // If display names are different from keys in `logData`, create a mapping
    const headerKeyMap = {
        "SN": "SN",
        "User/Plant Name": "user",
        "User Id": "USER_ID",
        "Alarm": "ALARAM",
        "Current KW": "LKW",
        "Capacity": "Plant_capacity",
        "Plant Location": "PLANT_LOCATION",
        "Total KWh": "TOTAL_KWH",
        "Todays KWh": "TODAYS_KWH",
        "Todays CUF": "TODAYS_CUF",
        "Todays Specific Yield": "TODAYS_Specific_Yield",
        "Todays PR": "TODAYS_PR",
        "Total Inverters": "NOI",
        "Status": "STATUS",
        " Commissioned Date": "PLANT_COMMISSIONED_DATE",
        "Subscription Expiry Date": "subscription_expiry_date",
        "Latitude": "LATITUDE",
        "Longitude": "LONGITUDE",
        "Mail Id": "mails_ids"
    };

    const exportToExcel = () => {
        const filteredData = logData.map(item => {
            let filteredItem = {};
            tableHeaders.forEach(header => {
                const key = headerKeyMap[header];
                filteredItem[header] = item[key]; // Use header as column name
            });
            return filteredItem;
        });

        const ws = XLSX.utils.json_to_sheet(filteredData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Dashboard");
        XLSX.writeFile(wb, "Dashboard.xlsx");
    };


    //Invoice

    const handleCreate = (data) => {
        console.log("Invoice created:", data);
        setShowInvoice(false);
        // Optionally: toast, refresh list, etc.
    };

    const totalTodaysKwh = filteredData.reduce((sum, item) => {
        return sum + (parseFloat(item.TODAYS_KWH) || 0);
    }, 0);

    const totalTotalKwh = filteredData.reduce((sum, item) => {
        return sum + (parseFloat(item.TOTAL_KWH) || 0);
    }, 0);

    const totalLkw = filteredData.reduce((sum, item) => {
        return sum + (parseFloat(item.LKW) || 0);
    }, 0);

    return (
        <>

            {/* <TopHeaderBusiness /> */}

            <div className="row my-2">
                <div className="col-md-12">
                    {loading && <p>Loading...</p>}
                    {error && <p style={{ color: "red" }}>{error}</p>}
                    <div
                        className="w-100"
                        style={{
                            backgroundColor: "#f8f9fa",
                            borderBottom: "2px solid #dee2e6",
                        }}
                    >
                        <div className="d-flex justify-content-between align-items-center px-3">
                            <p
                                style={{
                                    margin: 0,
                                    // fontWeight: "bold",
                                    color: "#343a40",
                                    fontSize: ".8rem"
                                }}
                            >
                                Plant Details

                                {/* <label htmlFor="entries" style={{ marginRight: '1px' }}>Show</label> */}
                                &nbsp;&nbsp;
                                <select
                                    id="entries"
                                    value={itemsPerPage}
                                    onChange={(e) => {
                                        setItemsPerPage(Number(e.target.value));

                                    }}
                                >
                                    <option value={12}>12</option>
                                    <option value={15}>15</option>
                                    <option value={20}>20</option>
                                    <option value={25}>25</option>
                                    <option value={50}>50</option>
                                    <option value={logData.length}>All</option> {/* Show all */}
                                </select>
                                <span style={{ marginLeft: '8px' }}>entries</span>
                            </p>

                            <label>
                                <input
                                    type="checkbox"
                                    checked={autoRefresh}
                                    onChange={() => setAutoRefresh(!autoRefresh)}
                                />&nbsp;
                                Auto Refresh
                            </label>




                            <div className="d-flex align-items-center">

                                <button
                                    className="btn btn-primary mx-1"
                                    onClick={() => {
                                        setSearchQuery(""); // ✅ Search Query Clear
                                        setShowAlarmOnly(false);   // ✅ Alarm filter reset
                                        setShowOfflineOnly(false);  // ✅ Offline filter reset
                                        setShowPartialOfflineOnly(false); // ✅ Partial offline filter reset
                                        setShowExpiryOnly(false)
                                        setShowOnlineOnly(false)
                                    }}
                                    style={{
                                        // width: "4.7rem",
                                        // height: "2rem",
                                        padding: ".41rem",
                                        fontSize: ".6rem",
                                        borderRadius: "1rem",
                                        textAlign: "center"
                                    }}
                                >
                                    Show All[{totalCount}]    
                                </button>




                                <button
                                    className="btn btn-danger mx-1"
                                    onClick={() => {
                                        setSearchQuery("Alarm"); // Alarm set karein
                                        setShowAlarmOnly(true);   // Alarm mode ON karein
                                        setShowOfflineOnly(false);  // ✅ Correctly enable offline filter
                                        setShowPartialOfflineOnly(false)
                                        setShowExpiryOnly(false)
                                        setShowOnlineOnly(false)
                                    }}
                                    style={{ padding: ".41rem", fontSize: ".6rem", borderRadius: "1rem", textAlign: "center" }}
                                >
                                    Alarm [{alaramCount}]
                                </button>


                                <button
                                    className="btn btn-danger mx-1"
                                    onClick={() => {
                                        setShowOfflineOnly(true);  // ✅ Correctly enable offline filter
                                        setShowAlarmOnly(false);
                                        setShowExpiryOnly(false)   // ✅ Disable alarm filter
                                        setSearchQuery("");        // ✅ Clear search query
                                        setShowPartialOfflineOnly(false)
                                        setShowOnlineOnly(false)
                                    }}
                                    style={{ padding: ".41rem", fontSize: ".6rem", borderRadius: "1rem" }}
                                >
                                    Offline [{offlineCount}]

                                </button>

                                <button
                                    className="btn btn-success mx-1"
                                    onClick={() => {
                                        setShowOfflineOnly(false);  // ✅ Correctly enable offline filter
                                        setShowAlarmOnly(false);
                                        setShowExpiryOnly(false)   // ✅ Disable alarm filter
                                        setSearchQuery("");        // ✅ Clear search query
                                        setShowPartialOfflineOnly(false)
                                        setShowOnlineOnly(true)
                                    }}
                                    style={{ padding: ".41rem", fontSize: ".6rem", borderRadius: "1rem" }}
                                >
                                    Online [{onlineCount}]

                                </button>



                                <button
                                    className="btn btn-warning mx-1"
                                    onClick={() => {
                                        setSearchQuery("");        // ✅ Clear search query
                                        setShowOfflineOnly(false);  // ✅ Correctly enable offline filter
                                        setShowAlarmOnly(false);   // ✅ Disable alarm filter
                                        setShowPartialOfflineOnly(true)
                                        setShowExpiryOnly(false)
                                        setShowOnlineOnly(false)

                                    }}
                                    style={{ padding: ".41rem", fontSize: ".6rem", borderRadius: "1rem" }}
                                >
                                    Partial Offline[{partialCount}]
                                </button>

                                <button
                                    className="btn btn-danger mx-1"
                                    onClick={() => {
                                        setShowOfflineOnly(false);  // ✅ Correctly enable offline filter
                                        setShowAlarmOnly(false);
                                        setShowExpiryOnly(true)   // ✅ Disable alarm filter
                                        setSearchQuery("");        // ✅ Clear search query
                                        setShowPartialOfflineOnly(false)
                                        setShowOnlineOnly(false)
                                    }}
                                    style={{ padding: ".41rem", fontSize: ".6rem", borderRadius: "1rem" }}
                                >
                                    Expiry Date [{expiryCount}]

                                </button>



                                {/* Search Input */}
                                <input
                                    type="text"
                                    className="form-control form-control-sm me-2"
                                    placeholder="Search..."
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    style={{ maxWidth: "150px", height: "1.8rem", borderRadius: "1rem" }}
                                />
                                {/* Search Button */}

                                <button
                                    className="btn btn-primary mx-1"
                                    onClick={exportToExcel}
                                    style={{ padding: ".41rem", fontSize: ".6rem", borderRadius: "1rem" }}
                                >
                                    Excel

                                </button>



                            </div>





                        </div>
                    </div>


                    <div className="table-responsive">
                        <table className="table table-hover table-bordered">
                            <thead className="text-center" style={{ backgroundColor: "rgb(253, 248, 228)" }}>
                                <tr>
                                    {tableHeaders.map((header, index) => (
                                        <th
                                            key={index}
                                            style={{
                                                color: "#56688A",
                                                padding: "6px 4px",
                                                fontSize: "12px",
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            {header}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan={tableHeaders.length} className="text-center">
                                            Loading...
                                        </td>
                                    </tr>
                                ) : currentData.length > 0 ? (
                                    currentData.map((item, rowIndex) => (
                                        <tr key={rowIndex}>
                                            <td className="text-center align-middle" style={{ padding: "5px", fontSize: "12px", color: "#333", whiteSpace: "nowrap" }}>
                                                {item.SN || ""}
                                            </td>

                                            {/* <td
                                                className="text-start align-middle"
                                                style={{
                                                    padding: "5px",
                                                    fontSize: "12px",
                                                    color: "#333",
                                                    whiteSpace: "nowrap",
                                                }}
                                            >


                                                <Link
                                                    to="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handleLoginClick(item.USER_ID, item.PASSWORD, item.USER_TYPE);
                                                    }}
                                                    style={{ textDecoration: "none", color: "#007BFF" }}
                                                >
                                                    {item.user || ""}
                                                </Link>


                                            </td> */}

                                            <td
                                                className="text-start align-middle"
                                                style={{
                                                    padding: "5px",
                                                    fontSize: "12px",
                                                    color: "#333",
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                <Link
                                                    to="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handleLoginClick(item.USER_ID, item.PASSWORD, item.USER_TYPE);
                                                    }}
                                                    style={{ textDecoration: "none", color: "#007BFF" }}
                                                >
                                                    {item.user || ""}
                                                </Link>
                                            </td>

                                            <td
                                                className="text-primary text-decoration-none"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => handleOpenModal(item)}
                                            >
                                                {item.USER_ID}
                                            </td>


                                            {/* <td className="blink" style={{ padding: "5px", fontSize: "12px", color: "red", whiteSpace: "nowrap" }}
                                                onClick={handleOpenModal2}
                                            >
                                                {item.ALARM || ""}
                                            </td> */}

                                            <td
                                                className="blink"
                                                style={{ padding: "5px", fontSize: "12px", color: "red", whiteSpace: "nowrap" }}
                                                onClick={() => handleOpenModal2(item)}
                                            >
                                                {item.ALARM || ""}
                                            </td>

                                            <td className="text-center align-middle" style={{ padding: "5px", fontSize: "12px", color: "#333", whiteSpace: "nowrap" }}>
                                                {item.LKW || ""}
                                            </td>

                                            <td className="text-center align-middle" style={{ padding: "5px", fontSize: "12px", color: "#333", whiteSpace: "nowrap" }}>
                                                {item.Plant_capacity || ""}
                                            </td>

                                            <td className="text-center align-middle" style={{ padding: "5px", fontSize: "12px", color: "#333", whiteSpace: "nowrap" }}>
                                                {item.PLANT_LOCATION || ""}
                                            </td>

                                            <td className="text-center align-middle" style={{ padding: "5px", fontSize: "12px", color: "#333", whiteSpace: "nowrap" }}>
                                                {item.TOTAL_KWH || ""}
                                            </td>

                                            <td className="text-center align-middle" style={{ padding: "5px", fontSize: "12px", color: "#333", whiteSpace: "nowrap" }}>
                                                {item.TODAYS_KWH || ""}
                                            </td>

                                            <td className="text-center align-middle" style={{ padding: "5px", fontSize: "12px", color: "#333", whiteSpace: "nowrap" }}>
                                                {item.TODAYS_CUF || ""}
                                            </td>

                                            <td className="text-center align-middle" style={{ padding: "5px", fontSize: "12px", color: "#333", whiteSpace: "nowrap" }}>
                                                {item.TODAYS_Specific_Yield || ""}
                                            </td>

                                            <td className="text-center align-middle" style={{ padding: "5px", fontSize: "12px", color: "#333", whiteSpace: "nowrap" }}>
                                                {item.TODAYS_PR || ""}
                                            </td>

                                            <td className="text-center align-middle" style={{ padding: "5px", fontSize: "12px", color: "#333", whiteSpace: "nowrap" }}>
                                                {item.NOI || ""}
                                            </td>

                                            {/* <td className="text-center align-middle" style={{ padding: "5px", fontSize: "12px", color: item.STATUS === 	"Offline" ? "red": item.STATUS === "Online" ? "green"  : item.STATUS === "Partial offline" ? "orange": "black", whiteSpace: "nowrap" }}>
                                            {item.STATUS || ""}
                                        </td> */}

                                            <td
                                                className={`text-center align-middle ${item.STATUS?.toLowerCase() === "offline" || item.STATUS?.toLowerCase() === "partial offline" ? "blink" : ""}`}
                                                style={{
                                                    padding: "5px",
                                                    fontSize: "12px",
                                                    color:
                                                        item.STATUS?.toLowerCase() === "offline"
                                                            ? "red"
                                                            : item.STATUS?.toLowerCase() === "online"
                                                                ? "green"
                                                                : item.STATUS?.toLowerCase() === "partial offline"
                                                                    ? "orange"
                                                                    : "black",
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                {item.STATUS || ""}
                                            </td>



                                            <td className="text-center align-middle" style={{ padding: "5px", fontSize: "12px", color: "#333", whiteSpace: "nowrap" }}>
                                                {item.PLANT_COMMISSIONED_DATE || ""}
                                            </td>

                                            {/* <td className="text-center align-middle" style={{ padding: "5px", fontSize: "12px", color: "#333", whiteSpace: "nowrap" }}>
                                            {item.subscription_expiry_date || ""}
                                        </td> */}

                                            <td
                                                className={`text-center align-middle ${new Date(item.subscription_expiry_date) < new Date() ||
                                                    new Date(item.subscription_expiry_date) <= new Date(new Date().setMonth(new Date().getMonth() + 1))
                                                    ? "blink"
                                                    : ""
                                                    }`}
                                                style={{
                                                    padding: "5px",
                                                    fontSize: "12px",
                                                    color:
                                                        new Date(item.subscription_expiry_date) < new Date()
                                                            ? "red" // Expired (Past)
                                                            : new Date(item.subscription_expiry_date) <= new Date(new Date().setMonth(new Date().getMonth() + 1))
                                                                ? "orange" // Within Next Month
                                                                : "#333", // Future Dates
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                {item.subscription_expiry_date || ""}
                                            </td>

                                            <td className="text-center align-middle" style={{ padding: "5px", fontSize: "12px", color: "#333", whiteSpace: "nowrap" }}>
                                                {item.LATITUDE || ""}
                                            </td>

                                            <td className="text-center align-middle" style={{ padding: "5px", fontSize: "12px", color: "#333", whiteSpace: "nowrap" }}>
                                                {item.LONGITUDE || ""}
                                            </td>

                                            <td className="text-center align-middle" style={{ padding: "5px", fontSize: "12px", color: "#333", whiteSpace: "nowrap" }}>
                                                {item.Mail_ids || ""}
                                            </td>


                                            <InvoiceModalPage
                                                show={showInvoice}
                                                handleClose={() => setShowInvoice(false)}
                                                handleCreate={handleCreate}
                                            />
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={tableHeaders.length} className="text-center">
                                            No data available
                                        </td>
                                    </tr>
                                )}
                            </tbody>

                            {/* ✅ FOOTER TOTAL */}
                            <tfoot>
                                <tr style={{ backgroundColor: "#f1f1f1", fontWeight: "bold" }}>
                                    <td colSpan={4} className="text-end">
                                        Total:
                                    </td>

                                    {/* LKW Total */}
                                    <td className="text-center">
                                        {totalLkw.toFixed(2)}
                                    </td>

                                    {/* Capacity skip */}
                                    <td></td>

                                    {/* Location skip */}
                                    <td></td>

                                    {/* TOTAL_KWH Total */}
                                    <td className="text-center">
                                        {totalTotalKwh.toFixed(2)}
                                    </td>

                                    {/* TODAYS_KWH Total */}
                                    <td className="text-center">
                                        {totalTodaysKwh.toFixed(2)}
                                    </td>

                                    {/* Remaining खाली */}
                                    <td colSpan={tableHeaders.length - 9}></td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>

                    <div style={{ textAlign: "right", marginTop: "10px" }}>
                        <button
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                            style={paginationButtonStyle}
                        >
                            Previous
                        </button>

                        {[...Array(totalPages)].map((_, index) => {
                            const isActive = currentPage === index + 1;
                            return (
                                <button
                                    key={index}
                                    onClick={() => handlePageChange(index + 1)}
                                    style={{
                                        ...paginationButtonStyle,
                                        backgroundColor: isActive ? "green" : "white",
                                        color: isActive ? "#fff" : "#356E35",
                                    }}
                                >
                                    {index + 1}
                                </button>
                            );
                        })}

                        <button
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            style={paginationButtonStyle}
                        >
                            Next
                        </button>
                    </div>

                </div>

            </div>


            {/* Pass Props to UpdateComponent */}
            {showModal && selectedUser && (
                <UpdateComponent
                    show={showModal}
                    handleClose={handleClose}
                    userData={selectedUser}
                    handleUpdate={handleUpdate}
                />
            )}

            {showModal2 && (
                <AlaramLogBusiness
                    show={showModal2}
                    handleClose={handleClose2}
                    alarmId={selectedAlarm?.id}
                    locCode={selectedAlarm?.locCode}
                />
            )}


        </>
    );
}

const containerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    marginBottom: "7px",
    border: "1px solid lightgray",
    padding: "3px",
    borderRadius: "7px"
};

const responsiveHeaderStyle = {
    fontWeight: "bold",
    margin: "0",
    display: "flex",
    flexWrap: "wrap"
};

const responsiveControlsStyle = {
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
    justifyContent: "center",
};

const inputStyle = {
    padding: "2px 2px",
    borderRadius: "14px",
    border: "1px solid #ccc",
    // marginLeft: "5px",  
    // fontSize: "10px",
};

const buttonStyle = {
    backgroundColor: "#007BFF",
    color: "#fff",
    border: "none",
    borderRadius: "14px",
    padding: "2px 9px",
    cursor: "pointer",
    fontSize: "10px",
};

const exportButtonStyle = {
    backgroundColor: "darkblue",
    color: "#fff",
    border: "none",
    borderRadius: "14px",
    padding: "3px 9px",
    cursor: "pointer",
    fontSize: "11px",
};

const exportButtonStyle2 = {
    backgroundColor: "#f44336",
    color: "#fff",
    border: "none",
    borderRadius: "14px",
    padding: "3px 9px",
    cursor: "pointer",
    fontSize: "11px",
};

const paginationButtonStyle = {
    backgroundColor: "white",
    color: "#356E35",
    border: "1px solid #ddd",
    padding: "5px 10px",
    borderRadius: "5px",
    margin: "0 5px",
    cursor: "pointer",
    fontSize: "14px",
};







